export default __webpack_public_path__ + "static/media/Calendar.5474a378.svg";